export interface Loading {
    loadingState: LoadingState;
}

export enum LoadingState {
    Loading,
    Error,
    Done,
}
